import React from "react";

import { Button, InputNumber, Modal } from "antd";

import { BackingSellerSelect } from "./selects";
import { BACKING_SUPPLIER_LABEL } from "./helpers";

const plural = ({
    n,
}) => `${n.toLocaleString()} line${n === 1 ? "" : "s"}`;

export const BULK_TITLES = {
    setBackingSeller: n => `Set the backing supplier on ${plural({ n })}`,
    adjustPricePct: n => `Adjust the contract price of ${plural({ n })}`,
    remove: n => `Remove ${plural({ n })} from this contract`
};

/**
 * The selection bar. With a whole page ticked it offers "Select all N matching this filter",
 * so a bulk action can target the filter rather than the ids on screen.
 */
export const BulkBar = ({ selectedCount, pageCount, total, allMatching, onSelectAllMatching, onAction, onClear }) => (
    <div style={{
        display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, padding: "8px 14px", marginBottom: 12,
        background: "#e6f4ff", border: "1px solid #91caff", borderRadius: 4
    }}>
        <b>{allMatching ? `All ${plural({ n: total })} matching this filter selected` : `${plural({ n: selectedCount })} selected`}</b>
        {!allMatching && selectedCount === pageCount && total > pageCount && (
            <a onClick={onSelectAllMatching}>Select all {total.toLocaleString()} matching this filter</a>
        )}
        <Button size="small" onClick={() => onAction({ action: "setBackingSeller" })}>Set backing supplier…</Button>
        <Button size="small" onClick={() => onAction({ action: "adjustPricePct" })}>Adjust price…</Button>
        <Button size="small" type="danger" onClick={() => onAction({ action: "remove" })}>Remove</Button>
        <div style={{ flex: 1 }} />
        <a onClick={onClear}>Clear selection</a>
    </div>
);

/** Confirm dialog for one bulk action; states the count and collects the action's value. */
export class BulkModal extends React.Component {

    state = { value: this.props.action === "setBackingSeller" ? null : undefined, running: false };

    run = async () => {
        this.setState({ running: true });
        try {
            await this.props.onRun({ value: this.state.value }); // success unmounts this modal
        } catch (e) {
            this.setState({ running: false });
        }
    };

    render() {
        const { action, count, onCancel } = this.props;
        const { value, running } = this.state;
        const invalidPct = action === "adjustPricePct" && (typeof value !== "number" || value === 0);
        return (
            <Modal
                visible
                title={BULK_TITLES[action](count)}
                okText={action === "remove" ? "Remove" : "Apply"}
                okType={action === "remove" ? "danger" : "primary"}
                okButtonProps={{ disabled: invalidPct }}
                confirmLoading={running}
                onOk={this.run}
                onCancel={onCancel}
            >
                {action === "setBackingSeller" && (
                    <div>
                        <p>{BACKING_SUPPLIER_LABEL}. Leave it empty to clear the backing supplier on these lines.</p>
                        <BackingSellerSelect value={value} onChange={v => this.setState({ value: v })} />
                    </div>
                )}
                {action === "adjustPricePct" && (
                    <div>
                        <p>
                            Changes each line's <b>current contract price</b> by this percentage, rounded to 2 decimals.
                            Use a negative number to lower prices. A line whose result would be 0 or less is skipped.
                        </p>
                        <InputNumber
                            autoFocus
                            step={0.5}
                            value={value}
                            formatter={v => `${v}%`}
                            parser={v => v.replace("%", "")}
                            onChange={v => this.setState({ value: v })}
                        />
                    </div>
                )}
                {action === "remove" && (
                    <p>
                        Removed lines stop pricing immediately and leave this list. Adding the same product again
                        restores its line.
                    </p>
                )}
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/term-contract/bulk.js